export default __webpack_public_path__ + "static/media/download.a569990b.svg";